import PropTypes from 'prop-types';
import { BsExclamationTriangle, BsStars } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import { useError } from '#globalContexts/ErrorContext';

import { useGeneratePendingEmails } from '../../../../models/aiCampaigns/mutations';
import { usePendingContacts } from '../../../../models/aiCampaigns/queries';

const PendingContactsBanner = ({ campaignId }) => {
	const { data: pendingData, isLoading } = usePendingContacts(campaignId);
	const generateMutation = useGeneratePendingEmails(campaignId);
	const { showError, showSuccess } = useError();

	const pendingCount = pendingData?.count || 0;

	const handleGenerate = async () => {
		try {
			await generateMutation.mutateAsync();
			showSuccess({
				title: 'E-Mail-Generierung gestartet',
				message: `E-Mails für ${pendingCount} neue Empfänger werden generiert.`,
			});
		} catch (error) {
			showError({
				title: 'Fehler',
				error,
			});
		}
	};

	// Don't render if loading or no pending contacts
	if (isLoading || pendingCount === 0) {
		return null;
	}

	return (
		<div className="bg-caution-200 border border-caution-500/40 rounded-card p-4 flex items-center justify-between">
			<div className="flex items-center gap-3">
				<BsExclamationTriangle className="h-5 w-5 text-caution-500 flex-shrink-0" />
				<div>
					<p className="text-sm font-medium text-caution-700">
						Für {pendingCount} Empfänger wurden noch keine E-Mails generiert
					</p>
					<p className="text-sm text-caution-700">
						Diese Empfänger wurden nach der ersten E-Mail-Generierung hinzugefügt.
					</p>
				</div>
			</div>
			<Button
				onClick={handleGenerate}
				disabled={generateMutation.isPending}
				variant="outline"
				size="sm"
				className="shrink-0"
			>
				<BsStars className="h-4 w-4" />
				{generateMutation.isPending ? 'Generiere...' : 'E-Mails generieren'}
			</Button>
		</div>
	);
};

PendingContactsBanner.propTypes = {
	campaignId: PropTypes.string.isRequired,
};

export default PendingContactsBanner;
